/**
 * AIMasteringToggle Component
 * Toggle for AI Mastering Suggestions panel with real-time analysis indicator
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Zap } from 'lucide-react';

export const AIMasteringToggle = ({
  showAIMastering,
  setShowAIMastering,
  isSimplifiedMode = false,
  audioCharacteristics = null,
  isPlaying = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showAIMastering ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowAIMastering(!showAIMastering)}
      className={`relative p-2 ${showAIMastering ? 'bg-gradient-to-r from-violet-500/20 to-rose-500/20 text-violet-400 border border-violet-500/50' : 'text-zinc-400 hover:text-white hover:bg-violet-500/20'}`}
      data-testid="ai-mastering-btn"
      title="AI Mastering Suggestions - Real-time analysis"
    >
      <Zap className="w-5 h-5" />
      {audioCharacteristics && isPlaying && (
        <span className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
      )}
    </Button>
  );
};

export default AIMasteringToggle;
